import { useIsOwner, useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { RefetchingIndicator } from '../../../../components/helpers/StatePresenter'
import { integrationsClient } from '../../../../utils/apollo/api'
// import { useOpenIntegrationModal } from '../../../../utils/routes/modals/modalsActions'
import { useRowActionsColumn } from '../../../../components/tables/Table'
import { useIntegrationActionsList } from '../../../../utils/actions/integrations/list'
import { useIntegrationsState } from '../_load/IntegrationsLoader'
import DataTable from '../../../../packages/kiti/components/table/DataTable'
import ListCounter from '../../../../components/helpers/ListCounter'
import { formatDate } from '@btime/helpers'

// TODO - CREATE actions
const IntegrationsTable = props => {
  const { t } = useTranslation('listIntegrations')
  const { integrations: data } = useIntegrationsState()
  const canEdit = useSessionPermission('editIntegration')
  // TODO - open integration details??
  // const openDetailsModal = useOpenIntegrationModal()
  const isOwner = useIsOwner()

  const columns = [
    {
      label: t('name'),
      headerSideContent: (
        <>
          <ListCounter
            client={integrationsClient}
            entity="integrations"
            filterName="IntegrationFilter"
            size="xsmall"
            bold
          />
          <RefetchingIndicator />
        </>
      ),
      dataIndex: 'name',
      bold: true,
      flex: 4
    },

    {
      label: t('service'),
      dataIndex: 'service',
      flex: 4
    },

    {
      label: t('createdAt'),
      dataIndex: 'insertedAt',
      sortIndex: 'INSERTED_AT',
      flex: 2,
      format: formatDate('DD/MM/YYYY HH:mm')
    },

    {
      label: t('updatedAt'),
      dataIndex: 'updatedAt',
      sortIndex: 'UPDATED_AT',
      flex: 2,
      format: formatDate('DD/MM/YYYY HH:mm')
    },

    {
      label: t('actions'),
      flex: 1,
      render: useRowActionsColumn(useIntegrationActionsList)
    }
  ]

  return (
    <DataTable
      rowKey="id"
      columns={columns}
      data={data}
      inPanel
      size="medium"
      // _TODO_onSelectAll={onSelectAll}
      {...props}
    />
  )
}

export default IntegrationsTable
